import { z } from 'zod';

import { isMoney, type Money } from '@nucleus-commerce/core';

/** One of the rates the address qualifies for, a custom title and price, or no shipping. */
export const shippingSchema = z
  .object({
    mode: z.enum(['none', 'rate', 'custom']),
    rateId: z.string(),
    title: z.string().trim().max(120, { error: 'draftOrders:shipping.validation.titleLength' }),
    price: z.custom<Money>(isMoney).nullable(),
  })
  .superRefine((v, ctx) => {
    if (v.mode === 'rate' && v.rateId === '') {
      ctx.addIssue({
        code: 'custom',
        path: ['rateId'],
        message: 'draftOrders:shipping.validation.rate',
      });
    }
    if (v.mode === 'custom') {
      if (v.title === '') {
        ctx.addIssue({
          code: 'custom',
          path: ['title'],
          message: 'draftOrders:shipping.validation.title',
        });
      }
      if (v.price === null || v.price.amount < 0) {
        ctx.addIssue({
          code: 'custom',
          path: ['price'],
          message: 'draftOrders:shipping.validation.price',
        });
      }
    }
  });

export type ShippingFormInput = z.input<typeof shippingSchema>;
export type ShippingFormOutput = z.output<typeof shippingSchema>;
